import {User} from 'hubbl-shared';

/**
 * Checks if a user has completed basic information required for onboarding.
 * Returns true if:
 * - User has SSO (customSSOProperties is not null), OR
 * - User has filled all basic fields: fullName, jobTitle, and department label
 */
export const checkBasicInfoComplete = (user: User | null): boolean => {
  if (!user) {
    return false;
  }

  // Skip basic info step if user has SSO
  if (user.customSSOProperties !== null) {
    return true;
  }

  // Check if all required fields are filled
  const hasFullName = user.fullName && user.fullName.trim() !== '';
  const hasJobTitle = user.jobTitle && user.jobTitle.trim() !== '';
  const hasDepartment =
    user.department &&
    (user.department.label?.en?.trim() !== '' ||
      user.department.label?.da?.trim() !== '');

  return Boolean(hasFullName && hasJobTitle && hasDepartment);
};


